import { MapToContext } from '@utils/objectWithDefault'

export class PackageSelection {
  constructor (packageSelectionData) {
    const defaultPackageSelectionResponse = {
      shipBobBox: {
        val: {
          packageFound: { val: false, type: Boolean },
          packageName: { val: '', type: String },
          packageType: { val: '', type: String },
          packageTypeId: { val: 0, type: Number },
          packageLength: { val: 0, type: Number },
          packageWidth: { val: 0, type: Number },
          packageHeight: { val: 0, type: Number },
          packageMappingLength: { val: 0, type: Number },
          packageMappingWidth: { val: 0, type: Number },
          packageMappingHeight: { val: 0, type: Number },
          totalWeight: { val: 0, type: Number },
          reason: {val: '', type: String},
          billableWeight: {val: 0, type: Number},
          dimensionalWeight: {val: 0, type: Number}
        },
        type: Object
      }
    }

    MapToContext(this, defaultPackageSelectionResponse, packageSelectionData)
  }
}
